import React from 'react'
import MatchChart from 'lib/components/charts/match-chart'
import Container from 'lib/components/charts/container'
import XAxis from 'lib/components/charts/x-axis'
import YAxis from 'lib/components/charts/y-axis'
import Grid from 'lib/components/charts/grid'
import SmallLabelXAxis from 'lib/components/charts/small-label-x-axis'
import SparkLine from 'lib/components/charts/shapes/spark-line'
import Title from './title'
import { asFullYear } from 'lib/format'
import { scaleLinear, scaleTime } from 'd3-scale'
import { extent } from 'd3-array'
import { getGutters } from 'lib/components/charts/layouts/gutters'

class LineChart extends React.PureComponent {
  static defaultProps = {
    data: [],
    width: 300,
    height: 225,
    formatX: asFullYear,
    formatY: n => n,
    scaleX: null,
    scaleY: null,
    labelX: '',
    labelY: ''
  }

  renderLine(x, y, { key, color, label, points }) {
    return (
      <SparkLine
        key={key}
        points={points}
        scaleX={x}
        scaleY={y}
        label={label}
        stroke={color}
      />
    )
  }

  getScaleY() {
    return this.props.scaleY ? this.props.scaleY.copy() : scaleLinear()
  }

  getScaleX() {
    return this.props.scaleX ? this.props.scaleX.copy() : scaleTime()
  }

  getDomainX() {
    let values = this.props.datasets.reduce((memo, dataset) => {
      return memo.concat(dataset.points.map(point => point.x))
    }, [])

    return values.length ? extent(values) : [new Date(0), new Date()]
  }

  getDomainY() {
    let values = this.props.datasets.reduce((memo, dataset) => {
      return memo.concat(dataset.points.map(point => point.y))
    }, [])

    return values.length ? extent(values) : []
  }

  render() {
    const {
      datasets,
      labelX,
      labelY,
      title,
      formatX,
      formatY,
      width,
      height
    } = this.props

    const period = this.getDomainX()

    const x = this.getScaleX()
      .domain(period)
      .nice(7)

    const y = this.getScaleY()
      .domain(datasets.length ? this.getDomainY() : [0.5, 4])
      .nice(4)

    let { left, top, bottom, right } = getGutters({
      width: width,
      height: height,
      left: {
        ticks: y.ticks(4),
        format: formatY,
        label: labelY.toUpperCase()
      },
      bottom: {
        ticks: x.ticks(4),
        format: formatX,
        label: labelX.toUpperCase()
      }
    })

    x.range([left, width - right])
    y.range([height - bottom, top])

    return (
      <Container width={width} height={height}>
        <Grid scaleX={x} scaleY={y} ticksX={x.ticks()} ticksY={y.ticks(4)} />

        <Title x={left} y={top}>
          {title}
        </Title>

        {datasets.map(dataset => this.renderLine(x, y, dataset))}

        <MatchChart breakpoint="large" width={width}>
          <XAxis
            label={labelX}
            scale={x}
            format={formatX}
            ticks={x.ticks()}
            height={bottom}
            y={y.range()[0]}
          />
        </MatchChart>

        <MatchChart breakpoint="small" width={width}>
          <SmallLabelXAxis
            label={period.map(formatX).join(' - ')}
            x={left}
            y={height - bottom}
            width={width - right}
          />
        </MatchChart>

        <YAxis
          label={labelY}
          scale={y}
          format={formatY}
          ticks={y.ticks(4)}
          height={height}
          width={left}
        />
      </Container>
    )
  }
}

export default LineChart



// WEBPACK FOOTER //
// ./src/components/charts/line-chart.js